import type { ReactNode } from 'react';
import { buildLogoutUrl } from '../auth/swa-auth';
import { Layout } from '../components/Layout';

/**
 * Access denied page.
 *
 * Neutral wording on purpose: no role names, no configuration hints, no
 * technical details - a rejected user must not learn how the authorisation is
 * built. Details live in the server log under the correlation id.
 */
export function AccessDeniedPage(): ReactNode {
  return (
    <Layout>
      <div className="card">
        <h1>Zugriff nicht moeglich</h1>
        <p>
          Ihr Konto ist derzeit nicht fuer diese Plattform freigegeben. Bitte wenden Sie sich an die
          IT-Administration, wenn Sie Zugriff benoetigen.
        </p>
        <a className="button button--ghost" href={buildLogoutUrl('/login')}>
          Abmelden
        </a>
      </div>
    </Layout>
  );
}
